import { render } from "./AdminPreloader.vue?vue&type=template&id=aec5d7b2&scoped=true"
import script from "./AdminPreloader.vue?vue&type=script&lang=js"
export * from "./AdminPreloader.vue?vue&type=script&lang=js"

import "./AdminPreloader.vue?vue&type=style&index=0&id=aec5d7b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec5d7b2"]])

export default __exports__